import { metrics } from "@/analytics/events";
import { DownloadPopupVisible, InstructionsPopupVisible } from "@/atoms";
import { IconButton, IconTheme } from "@/components/IconButton/IconButton";
import { UbisoftUserProfiles, useLogout } from "@/ubisoft/uplay";
import classNames from "classnames";
import { useAtomValue, useUpdateAtom } from "jotai/utils";
import React, { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router";
import styles from "./ArtbookControls.module.scss";
import { LangSelection } from "@/components/LangSelection";
export function UserControlsHolder(props) {
    return (React.createElement("div", { className: classNames(styles.controlPanel, styles.smallControlPanel, styles.groupUser, props.className) }, props.children));
}
export function UserControls() {
    var navigate = useNavigate();
    var logout = useLogout();
    var onLogout = function () {
        metrics.clickOnLogoutMasterBar();
        logout();
        navigate("..");
    };
    var setDownloadPopupVisible = useUpdateAtom(DownloadPopupVisible);
    var setDisplayInstructions = useUpdateAtom(InstructionsPopupVisible);
    return (React.createElement(UserControlsHolder, null,
        React.createElement(LangSelection, null),
        React.createElement(IconButton, { icon: require("@/public_assets/button_download.png"), iconHover: require("@/public_assets/button_download_hover.png"), onClick: function () {
                metrics.clickOnDownloadMasterBar();
                setDownloadPopupVisible(true);
            }, tooltip: {
                label: React.createElement(FormattedMessage, { defaultMessage: "download", id: "LaM7n1" }),
            } }),
        React.createElement(IconButton, { icon: require("@/public_assets/button_help.png"), iconHover: require("@/public_assets/button_help_hover.png"), tooltip: {
                label: (React.createElement(FormattedMessage, { defaultMessage: "display shortcuts", id: "YtHIdM" })),
            }, onClick: function () {
                setDisplayInstructions(true);
                metrics.clickOnOpenTutorial();
            } }),
        React.createElement(IconButton, { icon: require("@/public_assets/button_leave.png"), iconHover: require("@/public_assets/button_leave_hover.png"), theme: IconTheme.Dark, tooltip: {
                label: React.createElement(FormattedMessage, { defaultMessage: "Log out", id: "PlBReU" }),
            }, onClick: onLogout })));
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function useUbisoftAvatarURL() {
    var user = useAtomValue(UbisoftUserProfiles);
    var time = useMemo(function () { return Date.now(); }, []);
    if (user == null || user.length === 0)
        return null;
    return "".concat(process.env.UBISOFT_AVATAR_URL, "/").concat(user[0].userId, "/default_146_146.png?appId=").concat(process.env.UBISOFT_APP_ID, "&tm=").concat(time);
}
